<template>
  <!--
    Todo: As Nick noted, it's weird for a generic "blank"
    component to render a trial. I did this to not
    repeat all the timer / perception logic, because
    this is still a trial, and, as such, sends data.

    In the event we need two "blank"s for two exams,
    this will need to be made more generic.  -MD
  -->
  <ImagePairsTrial
    :displaySeconds="displaySeconds"
    @answered="handleResponse"
  />
</template>

<script>
import { ntDate } from '@neurotrack/web-core'
import essComponentProps from '@/mixins/essComponentProps'
import ImagePairsTrial from '@/components/exams/image-pairs/ImagePairsTrial/ImagePairsTrial.vue'

export default {
  data() {
    return {
      trial_start_time: null
    }
  },
  components: { ImagePairsTrial },
  mixins: [essComponentProps],
  mounted() {
    this.trial_start_time = ntDate.now()
  },
  methods: {
    handleResponse() {
      if (this.trial.accepted_input_types?.includes('VIDEO')) {
        this.handleTrialResponse()
        return
      }
      const { trial_start_time } = this
      /** video?? */
      const data = []
      this.handleTrialResponse({
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time,
        trial_end_time: ntDate.now(),
        metadata: {
          trial_scoring_type: 'target'
        },
        data,
        timeout: data.length === 0
      })
    }
  },
  computed: {
    displaySeconds() {
      return this.trial.display_seconds
    }
  }
}
</script>
